/* @flow */

export function getContentLang(): ?string {
  const body = document.querySelector('body');
  if (body) {
    return body.getAttribute('data-content-lang');
  }
}

export function setContentLang(lang: string): void {
  const body = document.querySelector('body');
  if (body) {
    body.setAttribute('data-content-lang', lang);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/utilities/lang.js